/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { MembershipLevelUpdateDto, UserInfoDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminUserService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminUserService
   * @name SetMembershipLevel
   * @summary Set User Membership Level
   * @request PATCH:/v1/admin/users/{id}/membership-level
   * @secure
   */
  setMembershipLevel = (id: number, data: MembershipLevelUpdateDto, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/admin/users/${id}/membership-level`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminUserService
   * @name GetUsers
   * @summary Get Users
   * @request GET:/v1/admin/users
   * @secure
   */
  getUsers = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 10
       */
      size?: number;
      /**
       * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @default ["signupDate,DESC"]
       */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<UserInfoDto[], any>({
      path: `/v1/admin/users`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminUserService
   * @name GetUser
   * @summary Get User by ID
   * @request GET:/v1/admin/users/{id}
   * @secure
   */
  getUser = (id: number, params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/admin/users/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
